import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer as fallback (in addition to cookies)
http.interceptors.request.use((config) => {
  const token = localStorage.getItem("st_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatMoney(pence, currency = "GBP", locale) {
  const value = (pence || 0) / 100;
  const cur = (currency || "GBP").toUpperCase();
  const loc = locale || (cur === "USD" ? "en-US" : "en-GB");
  try {
    return new Intl.NumberFormat(loc, { style: "currency", currency: cur }).format(value);
  } catch {
    const sym = cur === "USD" ? "$" : cur === "EUR" ? "€" : "£";
    return `${sym}${value.toFixed(2)}`;
  }
}

export function poundsToPence(pounds) {
  if (pounds === "" || pounds === null || pounds === undefined) return 0;
  const n = Number(pounds);
  if (!isFinite(n)) return 0;
  return Math.round(n * 100);
}

export function penceToPounds(pence) {
  return ((pence || 0) / 100).toFixed(2);
}

export function resolveImageUrl(imageUrl) {
  if (!imageUrl) return null;
  if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) return imageUrl;
  if (imageUrl.startsWith("/api/")) return `${BACKEND_URL}${imageUrl}`;
  return imageUrl;
}

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await http.post("/uploads/image", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { path, url }
}
